// material ui components
import Button from "@mui/material/Button";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
// libraries
import { useNavigate } from "react-router-dom";

import PrimaryButton from "../../../components/common/PrimaryButton";
// components
import ContractsListItem from "../../../components/contractListItem";
import { IContractDetailsResponseData } from "../../../setup/api/services/contract/models";
// constants
import { ROUTES } from "../../../setup/constants";
import { AuthConfig } from "../../../setup/context/config/authConfig";
// styles
import styles from "./styles.module.scss";

interface Props {
  transactions?: IContractDetailsResponseData[];
  handleNewTransaction: () => void;
}

const Transaction = ({ transactions, handleNewTransaction }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userId = AuthConfig.getUserInfo().id;

  const handleNavigation = () => {
    navigate(`${ROUTES.CONTRACTS_LIST}`);
  };
  return (
    <div className={styles.outerContainer}>
      {transactions && transactions?.length ? (
        <>
          <div className={styles["header"]}>
            <h2>{t("lbl_home_active_transactions_title")}</h2>
            <Button
              onClick={handleNavigation}
              className={classNames(styles["text_link"], styles["text"])}>
              <p className={classNames("subtitle2", "primary")}>
                {t("lbl_header_text_view_all")} {">"}
              </p>
            </Button>
          </div>
          <div>
            {transactions?.map((contract) => {
              return (
                <div className={styles["contract_wrapper"]} key={contract.id}>
                  <ContractsListItem
                    userId={userId}
                    smallerSection={true}
                    contract={contract}></ContractsListItem>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className={styles["container"]}>
          <img
            className={styles["no_transaction"]}
            src="/assets/images/svg/emptyTransaction.svg"
          />
          <div className={styles["text_wrapper"]}>
            <h2 className={styles["text_header"]}>
              {t("lbl_home_empty_state_title")}
            </h2>
            <p className={classNames(styles["text_description"], "p1")}>
              {t("lbl_home_empty_state_sub_title")}
            </p>
          </div>
          <PrimaryButton
            onClick={handleNewTransaction}
            id={`home_no_contract_create_contract`}
            style={{ maxWidth: "400px", margin: 0 }}>
            {t("lbl_buttons_start_transaction")}
          </PrimaryButton>
        </div>
      )}
    </div>
  );
};

export default Transaction;
